<template>
     <nav class="navbar navbar-expand-lg bg-primary navbar-primary">
        <div class="container">
            <a
                    href="/"
                    class="
                        navbar-brand
                    "
                >
                    <img
                        class="bi me-2"
                        src="/images/logo_white.png"
                        alt=""
                        width="40"
                        height="43"
                    />
                </a>
        
            <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navmenu"
                >
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navmenu">
                <ul
                    class="
                        nav
                        col-12 col-lg-auto
                        me-lg-auto
                        mb-2
                        justify-content-center
                        mb-md-0
                    "
                >
                    <li v-if="auth != null">
                        <inertia-link
                            :href="route('dashboard')"
                            class="nav-link px-2 text-white"
                            >Home</inertia-link
                        >
                    </li>
                </ul>
                <ul class="navbar-nav ms-auto">


                    <div class="dropdown text-end" v-if="auth != null">
                        <a
                            href="#"
                            class="
                                d-block
                                link-light
                                text-decoration-none
                                dropdown-toggle
                            "
                            id="dropdownUser1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                fill="currentColor"
                                class="bi bi-person-circle"
                                viewBox="0 0 16 16"
                            >
                                <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                                <path
                                    fill-rule="evenodd"
                                    d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                                />
                            </svg>
                        </a>
                        <ul
                            class="dropdown-menu text-small"
                            aria-labelledby="dropdownUser1"
                        >
                            
                            <li>
                                <inertia-link
                                    :href="route('logout')"
                                    method="post"
                                    as="button"
                                    class="dropdown-item"
                                    >Esci</inertia-link
                                >
                            </li>
                        </ul>
                    </div>
                </ul>
            </div>
        </div>
    </nav> 
</template>
<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters(["auth"]),
    },
};
</script>
